import {User} from '../../../redux/entities/user';
import {Link} from 'react-router-dom';
import {RoutePaths} from '../../../router/RoutePaths';
import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import styles from './SidebarPanel.module.scss';
import {NavLink, Stack, Tooltip} from '@mantine/core';
import StyledActionButton from '../../util/widgets/StyledActionButton/StyledActionButton';

export const MenuItemsForRole = (currentUser: User | null, collapsed?: boolean, onOpenExport?: () => void, onOpenAuditLogs?: () => void) => {
  const fg = '#FFFFFF';
  const normalize = (s?: string) => (s ?? '').trim().toLowerCase();
  const userRole = normalize(currentUser?.role?.roleName);
  const isAllowedFor = (allowedRoles?: string[]) => {
    if (!allowedRoles || allowedRoles.length === 0) return true;
    const normalizedAllowed = allowedRoles.map(normalize);
    return normalizedAllowed.includes(userRole);
  };

  // allowedRoles: if provided, the item is only visible for those roles
  const links: { label: string; icon: any; to?: string; allowedRoles?: string[]; onClick?: () => void }[] = [
    {
      label: 'Withdrawals',
      icon: 'truck',
      to: RoutePaths.privatePaths.configurationPaths.withdrawalManagement,
      allowedRoles: ['Administrator', 'Volunteer', 'Team Member', 'Warehouse']
    },
    {
      label: 'Deposits',
      icon: 'box',
      to: RoutePaths.privatePaths.configurationPaths.depositManagement,
      allowedRoles: ['Administrator', 'Volunteer', 'Warehouse']
    },
    {
      label: 'Inventory',
      icon: 'clipboard-list',
      to: RoutePaths.privatePaths.configurationPaths.inventoryManagement,
      allowedRoles: ['Administrator', 'Volunteer', 'Team Member']
    },
    { label: 'Export', icon: 'file', onClick: onOpenExport, allowedRoles: ['Administrator'] },
    { label: 'Audit Logs', icon: 'history', onClick: onOpenAuditLogs, allowedRoles: ['Administrator'] },
    { label: 'Users', icon: 'user', to: RoutePaths.privatePaths.configurationPaths.userManagement, allowedRoles: ['Administrator'] },
  ];

  const renderExpanded = () => (
    <div>
      {links.filter((l) => isAllowedFor(l.allowedRoles)).map((link) => {
        const content = (
          <NavLink
            component={(link.to ? (Link as any) : 'button') as any}
            to={link.to as any}
            label={link.label}
            rightSection={<FontAwesomeIcon icon={link.icon as any}/>}
            styles={{
              root: {
                color: fg,
                paddingTop: 6,
                paddingBottom: 6,
                paddingLeft: 10,
                paddingRight: 6,
                margin: '2px 6px',
                borderRadius: 6,
                // Make label text turn black on hover (keep background/other styling intact)
                '&:hover .mantine-NavLink-label': {
                  color: '#000000',
                },
              },
              label: {
                color: fg,
                fontSize: '0.95rem',
              },
              rightSection: { marginRight: '1rem' },
            }}
            onClick={link.onClick}
            className={styles['menu-item']}
          />
        );

        return (
          <React.Fragment key={link.label}>{content}</React.Fragment>
        );
      })}
    </div>
  );

  const renderCollapsed = () => (
    <Stack align="center" spacing={12} style={{ marginTop: '0.5rem' }}>
      {links.filter((l) => isAllowedFor(l.allowedRoles)).map((it) => {
        const content = (
          <Tooltip label={it.label} position={"right"} withinPortal zIndex={3000}>
            {/* Wrap in a native span so Mantine Tooltip can attach refs/handlers reliably */}
            <span style={{ display: 'inline-flex' }} aria-label={it.label}>
              <StyledActionButton
                to={it.to as any}
                size="lg"
                color={fg}
                icon={it.icon as any}
                onClick={it.onClick}
              >
              </StyledActionButton>
            </span>
          </Tooltip>
        );

        return (
          <React.Fragment key={it.label}>{content}</React.Fragment>
        );
      })}
    </Stack>
  );

  return collapsed ? renderCollapsed() : renderExpanded();
};
